import { useMemo } from 'react';
import { useReduxSelector } from '@applyboard/ab-common';
import { additionalAttachmentSelector } from "../selectors/requirements";
export default function useAdditionalAttachments(requirementId) {
  var selector = useMemo(function () {
    return additionalAttachmentSelector(requirementId);
  }, [requirementId]);
  return useReduxSelector(selector);
}